import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { environment } from '@env/environment';
import { switchMap } from 'rxjs/operators';
import { AuthenticationService } from '../authentication/authentication.service';
import { User } from 'oidc-client-ts';
import { KeycloakService } from 'keycloak-angular';
import { Logger } from '../logger.service';

const log = new Logger('HttpTokenInterceptor');
@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  private authenticationService!: AuthenticationService;
  //private keycloak: KeycloakService;
  private token: string | undefined | null;
  constructor(private injector: Injector, private keycloak: KeycloakService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.authenticationService === undefined) {
      this.authenticationService = this.injector.get(AuthenticationService);
    }
    if (this.keycloak === undefined) {
      this.keycloak = this.injector.get(KeycloakService);
    }
    let language = localStorage.getItem('language');
    if (!language) {
      language = 'en-ca';
    }
    if (this.authenticationService.checkIsSSOLogin()) {
      let token = this.authenticationService.getSSOToken();
      if (!this.token) {
        this.token = token;
      }
      // if (this.token !== token) {
      //    this.authenticationService.toastService.error('Token has been updated.');
      //   log.error(`Token: ${token}, Url: ${req.url}`);
      // }
      return next.handle(
        req.clone({
          setHeaders: {
            Authorization: 'Bearer ' + token,
            'Accept-Language': 'en-ca',
            'App-Version': environment.appVersion,
          },
        })
      );
    } else {
      return this.authenticationService.getCurrentUserToken().pipe(
        switchMap((token: string) => {
          if (!this.token) {
            this.token = token;
          }
          // if (this.token !== token) {
          //   this.authenticationService.toastService.error('Token has been updated.');
          //   log.error(`Token: ${token}, Url: ${req.url}`);
          // }
          return next.handle(
            req.clone({
              setHeaders: {
                Authorization: 'Bearer ' + token,
                'Accept-Language': 'en-ca',
                'App-Version': environment.appVersion,
              },
            })
          );
        })
      );
    }
  }
}
